import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import Navbar from './Navbar';
import Footer from './Footer';
import { init, send } from 'emailjs-com';

// Initialize EmailJS
init("d1zH6UNPIGfFtdCEu");

// Translation content
const translations = {
  en: {
    title: "Refer & Earn - Special Cashback Offer",
    subtitle: "Refer your friends and family to get cashback on solar installations!",
    heroTitle: "Earn Cashback When You Refer",
    heroDescription: "Help your loved ones go solar and earn cashback rewards based on the system size they install.",
    offerTitle: "Cashback Offer Structure",
    offerSubtitle: "The more they install, the more you earn!",
    offer3_5: "3–5 kW Installation",
    offer5_8: "5–8 kW Installation",
    offer8_10: "8–10 kW Installation",
    offer10Plus: "10 kW+ Installation",
    cashback: "Cashback",
    howItWorks: "How It Works",
    step1Title: "Step 1: Share Your Referral",
    step1Desc: "Refer your friends and family members interested in solar. Call us to register your referral.",
    step2Title: "Step 2: They Get Solar Installed",
    step2Desc: "Your referral installs a solar system through Lunar Electric and completes the installation.",
    step3Title: "Step 3: You Get Cashback",
    step3Desc: "Once the installation is complete, you receive cashback directly to your bank account.",
    ctaTitle: "Ready to Start Earning?",
    ctaDescription: "Call us now to refer your friends and start earning cashback today!",
    getReferralLink: "Get Your Referral Link",
    contactUs: "Contact Us",
    callNow: "Call Now",
    termsLink: "Terms & Conditions",
    disclaimer: "Disclaimer: Terms and conditions apply. Cashback will be credited only after successful completion and verification of the referred installation.",
    legalNote: "This offer is subject to terms and conditions. Please read our Terms & Conditions before participating.",
    navigateToMain: "Explore Our Services",
    benefitsTitle: "Why Refer with Lunar Electric?",
    benefit1Title: "Trusted Company",
    benefit1Desc: "Lunar Electric is a trusted name in solar installations across India.",
    benefit2Title: "Easy Process",
    benefit2Desc: "Simple referral process with hassle-free cashback payments.",
    benefit3Title: "Fair Rewards",
    benefit3Desc: "Transparent cashback structure based on system capacity."
  },
  kn: {
    title: "ಉಲ್ಲೇಖಿಸಿ ಮತ್ತು ಸಂಪಾದಿಸಿ - ವಿಶೇಷ ಕ್ಯಾಶ್ಬ್ಯಾಕ್ ಆಫರ್",
    subtitle: "ನಿಮ್ಮ ಸ್ನೇಹಿತರು ಮತ್ತು ಕುಟುಂಬದವರನ್ನು ಉಲ್ಲೇಖಿಸಿ ಸೌರ ಶಕ್ತಿ ಸ್ಥಾಪನೆಗಳಿಗೆ ಕ್ಯಾಶ್ಬ್ಯಾಕ್ ಪಡೆಯಿರಿ!",
    heroTitle: "ನೀವು ಉಲ್ಲೇಖಿಸಿದಾಗ ಕ್ಯಾಶ್ಬ್ಯಾಕ್ ಸಂಪಾದಿಸಿ",
    heroDescription: "ನಿಮ್ಮ ಪ್ರೀತಿಪಾತ್ರರಿಗೆ ಸೌರ ಶಕ್ತಿಯನ್ನು ಅಳವಡಿಸಲು ಸಹಾಯ ಮಾಡಿ ಮತ್ತು ಅವರು ಸ್ಥಾಪಿಸುವ ವ್ಯವಸ್ಥೆಯ ಗಾತ್ರದ ಆಧಾರದ ಮೇಲೆ ಕ್ಯಾಶ್ಬ್ಯಾಕ್ ರಿವಾರ್ಡ್ಗಳನ್ನು ಸಂಪಾದಿಸಿ.",
    offerTitle: "ಕ್ಯಾಶ್ಬ್ಯಾಕ್ ಆಫರ್ ರಚನೆ",
    offerSubtitle: "ಅವರು ಹೆಚ್ಚು ಸ್ಥಾಪಿಸಿದರೆ, ನೀವು ಹೆಚ್ಚು ಸಂಪಾದಿಸುತ್ತೀರಿ!",
    offer3_5: "3–5 kW ಸ್ಥಾಪನೆ",
    offer5_8: "5–8 kW ಸ್ಥಾಪನೆ",
    offer8_10: "8–10 kW ಸ್ಥಾಪನೆ",
    offer10Plus: "10 kW+ ಸ್ಥಾಪನೆ",
    cashback: "ಕ್ಯಾಶ್ಬ್ಯಾಕ್",
    howItWorks: "ಇದು ಹೇಗೆ ಕೆಲಸ ಮಾಡುತ್ತದೆ",
    step1Title: "ಹಂತ 1: ನಿಮ್ಮ ಉಲ್ಲೇಖವನ್ನು ಹಂಚಿಕೊಳ್ಳಿ",
    step1Desc: "ಸೌರ ಶಕ್ತಿಯಲ್ಲಿ ಆಸಕ್ತಿ ಇರುವ ಸ್ನೇಹಿತರು ಮತ್ತು ಕುಟುಂಬದ ಸದಸ್ಯರನ್ನು ಉಲ್ಲೇಖಿಸಿ. ನಿಮ್ಮ ಉಲ್ಲೇಖವನ್ನು ನೋಂದಾಯಿಸಲು ನಮ್ಮನ್ನು ಕರೆ ಮಾಡಿ.",
    step2Title: "ಹಂತ 2: ಅವರು ಸೌರ ಶಕ್ತಿಯನ್ನು ಸ್ಥಾಪಿಸುತ್ತಾರೆ",
    step2Desc: "ನಿಮ್ಮ ಉಲ್ಲೇಖ ಲೂನರ್ ಎಲೆಕ್ಟ್ರಿಕ್ ಮೂಲಕ ಸೌರ ವ್ಯವಸ್ಥೆಯನ್ನು ಸ್ಥಾಪಿಸುತ್ತಾರೆ ಮತ್ತು ಸ್ಥಾಪನೆಯನ್ನು ಪೂರ್ಣಗೊಳಿಸುತ್ತಾರೆ.",
    step3Title: "ಹಂತ 3: ನೀವು ಕ್ಯಾಶ್ಬ್ಯಾಕ್ ಪಡೆಯಿರಿ",
    step3Desc: "ಸ್ಥಾಪನೆ ಪೂರ್ಣಗೊಂಡ ನಂತರ, ನೀವು ನಿಮ್ಮ ಬ್ಯಾಂಕ್ ಖಾತೆಗೆ ನೇರವಾಗಿ ಕ್ಯಾಶ್ಬ್ಯಾಕ್ ಪಡೆಯುತ್ತೀರಿ.",
    ctaTitle: "ಸಂಪಾದಿಸಲು ಸಿದ್ಧರಿದ್ದೀರಾ?",
    ctaDescription: "ನಿಮ್ಮ ಸ್ನೇಹಿತರನ್ನು ಉಲ್ಲೇಖಿಸಲು ನಮ್ಮನ್ನು ಈಗ ಕರೆ ಮಾಡಿ ಮತ್ತು ಇಂದೇ ಕ್ಯಾಶ್ಬ್ಯಾಕ್ ಸಂಪಾದಿಸಲು ಪ್ರಾರಂಭಿಸಿ!",
    getReferralLink: "ನಿಮ್ಮ ಉಲ್ಲೇಖ ಲಿಂಕ್ ಪಡೆಯಿರಿ",
    contactUs: "ನಮ್ಮನ್ನು ಸಂಪರ್ಕಿಸಿ",
    callNow: "ಈಗ ಕರೆ ಮಾಡಿ",
    termsLink: "ನಿಯಮಗಳು ಮತ್ತು ಷರತ್ತುಗಳು",
    disclaimer: "ದೂರು: ನಿಯಮಗಳು ಮತ್ತು ಷರತ್ತುಗಳು ಅನ್ವಯಿಸುತ್ತವೆ. ಉಲ್ಲೇಖಿಸಿದ ಸ್ಥಾಪನೆಯ ಯಶಸ್ವಿ ಪೂರ್ಣಗೊಳಿಸುವಿಕೆ ಮತ್ತು ಪರಿಶೀಲನೆಯ ನಂತರ ಮಾತ್ರ ಕ್ಯಾಶ್ಬ್ಯಾಕ್ ಶಾಲೆಗೆ ಸಲ್ಲಿಸಲಾಗುತ್ತದೆ.",
    legalNote: "ಈ ಆಫರ್ ನಿಯಮಗಳು ಮತ್ತು ಷರತ್ತುಗಳಿಗೆ ಒಳಪಟ್ಟಿರುತ್ತದೆ. ಭಾಗವಹಿಸುವ ಮೊದಲು ನಮ್ಮ ನಿಯಮಗಳು ಮತ್ತು ಷರತ್ತುಗಳನ್ನು ಓದಿ.",
    navigateToMain: "ನಮ್ಮ ಸೇವೆಗಳನ್ನು ಅನ್ವೇಷಿಸಿ",
    benefitsTitle: "ಲೂನರ್ ಎಲೆಕ್ಟ್ರಿಕ್ ನೊಂದಿಗೆ ಏಕೆ ಉಲ್ಲೇಖಿಸಬೇಕು?",
    benefit1Title: "ವಿಶ್ವಾಸಾರ್ಹ ಕಂಪನಿ",
    benefit1Desc: "ಲೂನರ್ ಎಲೆಕ್ಟ್ರಿಕ್ ಭಾರತದಾದ್ಯಂತ ಸೌರ ಸ್ಥಾಪನೆಗಳಲ್ಲಿ ವಿಶ್ವಾಸಾರ್ಹ ಹೆಸರು.",
    benefit2Title: "ಸುಲಭ ಪ್ರಕ್ರಿಯೆ",
    benefit2Desc: "ಸರಳ ಉಲ್ಲೇಖ ಪ್ರಕ್ರಿಯೆ ಮತ್ತು ತೊಂದರೆ-ರಹಿತ ಕ್ಯಾಶ್ಬ್ಯಾಕ್ ಪಾವತಿಗಳು.",
    benefit3Title: "ನ್ಯಾಯಯುತ ರಿವಾರ್ಡ್ಗಳು",
    benefit3Desc: "ವ್ಯವಸ್ಥೆಯ ಸಾಮರ್ಥ್ಯದ ಆಧಾರದ ಮೇಲೆ ಪಾರದರ್ಶಕ ಕ್ಯಾಶ್ಬ್ಯಾಕ್ ರಚನೆ."
  },
  'kn-en': {
    title: "Refer & Earn - Special Cashback Offer",
    subtitle: "Nimma snehitaru mattu kutumbadavarannu ullekhisi solar installationsgalige cashback padeyiri!",
    heroTitle: "Neenu ullekhisidaga Cashback sampadisi",
    heroDescription: "Nimma priitipatrarige solar shaktiyannu alavadisalu sahayamadi mattu avaru stapisuv vyavastheya gatradha aadharada mele cashback rewards annu sampadisi.",
    offerTitle: "Cashback Offer Rachane",
    offerSubtitle: "Avaru hechu stapisidare, neenu hechu sampadisuttirri!",
    offer3_5: "3–5 kW stapane",
    offer5_8: "5–8 kW stapane",
    offer8_10: "8–10 kW stapane",
    offer10Plus: "10 kW+ stapane",
    cashback: "Cashback",
    howItWorks: "Idu hege kelasa maduttade?",
    step1Title: "Hanta 1: Nimma ullekhavannu hanchikolli",
    step1Desc: "Solar shaktiyalli aasakti iruva snehitaru mattu kutumbada sadasyarannu ullekhisi. Nimma ullekhavannu nondayisalu nammannu kare madi.",
    step2Title: "Hanta 2: Avaru solar shaktiyannu stapisuttare",
    step2Desc: "Nimma ullekh Lunar Electric moolak solar vyavastheyannu stapisuttare mattu stapaneyannu purlagolisuttare.",
    step3Title: "Hanta 3: Neenu cashback padeyiri",
    step3Desc: "Stapane purlagond nimma, neenu nimma bank khatege neryavaagi cashback padeyuttirri.",
    ctaTitle: "Sampadisalu siddhariddirya?",
    ctaDescription: "Nimma snehitarannu ullekhisalu nammannu iga kare madi mattu indye cashback sampadisi prarambisi!",
    getReferralLink: "Nimma ullekh link padeyiri",
    contactUs: "Nammannu samparkisi",
    callNow: "Iga kare madi",
    termsLink: "Niyamagalu mattu shartugalu",
    disclaimer: "Disclaimer: Niyamagalu mattu shartugalu anvyayisuttave. Ullekhisida stapaneya yashasvi purnagolisuva mattu parishilaneya nantara matra cashback shalige sallalisalaguttade.",
    legalNote: "Ee offer niyamagalu mattu shartugalige olpattiruttade. Bhagavahisuv modalu namma niyamagalu mattu shartugalannu odi.",
    navigateToMain: "Namma sevegalannu anveshisi",
    benefitsTitle: "Lunar Electric nodhige yeke ullekhisabekada?",
    benefit1Title: "Vishvasarha company",
    benefit1Desc: "Lunar Electric bharatadaadyanta solar stapanegalalli vishvasarha hesaru.",
    benefit2Title: "Sulabha prakriye",
    benefit2Desc: "Sarala ullekh prakriye mattu tondare-raheta cashback patigalu.",
    benefit3Title: "Nyayayuta rewards",
    benefit3Desc: "Vyavastheya samarthyadha aadharada mele parardarshak cashback rachane."
  }
};

function ReferralLandingPage() {
  // Get language from URL parameter
  const urlParams = new URLSearchParams(window.location.search);
  const langParam = urlParams.get('lang') || 'en';
  const lang = ['en', 'kn', 'kn-en'].includes(langParam) ? langParam : 'en';
  
  const t = translations[lang];
  
  // Form state
  const [formData, setFormData] = useState({
    category: 'residential',
    name: '',
    phone: '',
    email: '',
    pincode: '',
    city: '',
    monthlyBill: '',
    companyName: ''
  });
  
  // Determine which image to use based on language
  const getImageSrc = () => {
    // In React, public folder files should be referenced from root with leading slash
    if (lang === 'kn') {
      return '/img/poster1 full kannada.png';
    } else if (lang === 'kn-en') {
      return '/img/poster1 english script cut.png';
    } else {
      return '/img/poster1.png';
    }
  };

  useEffect(() => {
    // Scroll to top on mount
    window.scrollTo(0, 0);
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    const emailData = {
      name: formData.name,
      email: formData.email || 'Not provided',
      subject: formData.phone,
      message: `REFERRAL LANDING PAGE CONTACT FORM DETAILS:
Category: ${formData.category}
Phone: ${formData.phone}
Email: ${formData.email || 'Not provided'}
Pincode: ${formData.pincode || 'Not provided'}
City: ${formData.city || 'Not provided'}
Monthly Bill: ${formData.monthlyBill || 'Not provided'}
Company Name: ${formData.companyName || 'Not provided'}

This is a contact request from the Lunar Electric referral landing page.`
    };

    send('service_9uk4fgz', 'template_uuwsowl', emailData)
      .then((response) => {
        console.log('Contact request received', response.status, response.text);
        setFormData({
          category: 'residential',
          name: '',
          phone: '',
          email: '',
          pincode: '',
          city: '',
          monthlyBill: '',
          companyName: ''
        });
        alert('Thank you! We will contact you soon.');
      })
      .catch((err) => {
        console.error('Failed to send contact request', err);
        alert('Failed to send request, please try again.');
      });
  };

  return (
    <>
      <Helmet>
        {/* Prevent search engine indexing */}
        <meta name="robots" content="noindex, nofollow" />
        <meta name="googlebot" content="noindex, nofollow" />
        <title>{t.title} - Lunar Electric</title>
        <meta name="description" content={t.heroDescription} />
      </Helmet>
      
      <div className="referral-landing-page" style={{ fontFamily: "'Poppins', sans-serif", minHeight: '100vh', backgroundColor: '#f5f5f5' }}>
        {/* Navbar */}
        <Navbar />
        
        {/* Header Section with Image */}
        <header style={{ 
          position: 'relative', 
          width: '100%', 
          textAlign: 'center',
          padding: '0',
          margin: '0',
          lineHeight: '0',
          height: 'auto',
          display: 'block',
          flexDirection: 'unset',
          justifyContent: 'unset',
          alignItems: 'unset',
          boxShadow: 'none'
        }}>
          <img 
            src={getImageSrc()} 
            alt={t.heroTitle}
            style={{
              maxWidth: '100%',
              height: 'auto',
              display: 'block',
              margin: '0',
              padding: '0',
              verticalAlign: 'bottom'
            }}
          />
        </header>

        {/* Main Content */}
        <main style={{ maxWidth: '1200px', margin: '0 auto', padding: '2rem 1rem' }}>
          
          {/* Hero Section */}
          <section style={{ 
            textAlign: 'center', 
            marginBottom: '4rem',
            padding: '2rem 0'
          }}>
            <h1 style={{ 
              fontSize: '2.5rem', 
              color: '#1F3A93', 
              marginBottom: '1rem',
              fontWeight: '700'
            }}>
              {t.heroTitle}
            </h1>
            <p style={{ 
              fontSize: '1.2rem', 
              color: '#666', 
              maxWidth: '800px',
              margin: '0 auto',
              lineHeight: '1.6'
            }}>
              {t.heroDescription}
            </p>
          </section>

          {/* Compact Form Section */}
          <section style={{ 
            marginBottom: '4rem',
            padding: '3rem 2rem',
            backgroundColor: 'white',
            borderRadius: '10px',
            boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
          }}>
            <div style={{ maxWidth: '600px', margin: '0 auto' }}>
              <h3 style={{ 
                textAlign: 'center', 
                fontSize: '1.8rem', 
                color: '#1F3A93',
                marginBottom: '1rem'
              }}>
                Get a Free Quote
              </h3>
              
              {/* Category Selection */}
              <div style={{ marginBottom: '1.5rem', textAlign: 'center' }}>
                <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center', flexWrap: 'wrap' }}>
                  <label style={{ 
                    display: 'flex', 
                    alignItems: 'center', 
                    gap: '0.5rem',
                    cursor: 'pointer',
                    padding: '0.75rem 1.5rem',
                    border: `2px solid ${formData.category === 'residential' ? '#1F3A93' : '#ddd'}`,
                    borderRadius: '5px',
                    backgroundColor: formData.category === 'residential' ? '#f0f4ff' : 'white'
                  }}>
                    <input
                      type="radio"
                      name="category"
                      value="residential"
                      checked={formData.category === 'residential'}
                      onChange={handleInputChange}
                      style={{ margin: 0 }}
                    />
                    <span>Residential</span>
                  </label>
                  <label style={{ 
                    display: 'flex', 
                    alignItems: 'center', 
                    gap: '0.5rem',
                    cursor: 'pointer',
                    padding: '0.75rem 1.5rem',
                    border: `2px solid ${formData.category === 'commercial' ? '#1F3A93' : '#ddd'}`,
                    borderRadius: '5px',
                    backgroundColor: formData.category === 'commercial' ? '#f0f4ff' : 'white'
                  }}>
                    <input
                      type="radio"
                      name="category"
                      value="commercial"
                      checked={formData.category === 'commercial'}
                      onChange={handleInputChange}
                      style={{ margin: 0 }}
                    />
                    <span>Commercial</span>
                  </label>
                </div>
              </div>

              <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '1rem' }}>
                  <input
                    type="text"
                    name="name"
                    placeholder="Full Name *"
                    value={formData.name}
                    onChange={handleInputChange}
                    required
                    style={{
                      padding: '0.75rem',
                      border: '1px solid #ddd',
                      borderRadius: '5px',
                      fontSize: '1rem'
                    }}
                  />
                  <input
                    type="tel"
                    name="phone"
                    placeholder="Phone Number *"
                    value={formData.phone}
                    onChange={handleInputChange}
                    required
                    style={{
                      padding: '0.75rem',
                      border: '1px solid #ddd',
                      borderRadius: '5px',
                      fontSize: '1rem'
                    }}
                  />
                </div>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '1rem' }}>
                  <input
                    type="text"
                    name="pincode"
                    placeholder="Pin Code *"
                    value={formData.pincode}
                    onChange={handleInputChange}
                    required
                    style={{
                      padding: '0.75rem',
                      border: '1px solid #ddd',
                      borderRadius: '5px',
                      fontSize: '1rem'
                    }}
                  />
                  <input
                    type="text"
                    name="city"
                    placeholder="City *"
                    value={formData.city}
                    onChange={handleInputChange}
                    required
                    style={{
                      padding: '0.75rem',
                      border: '1px solid #ddd',
                      borderRadius: '5px',
                      fontSize: '1rem'
                    }}
                  />
                </div>
                {formData.category === 'residential' && (
                  <select
                    name="monthlyBill"
                    value={formData.monthlyBill}
                    onChange={handleInputChange}
                    required
                    style={{
                      padding: '0.75rem',
                      border: '1px solid #ddd',
                      borderRadius: '5px',
                      fontSize: '1rem'
                    }}
                  >
                    <option value="">Monthly Bill Range *</option>
                    <option value="less-than-1500">Less than ₹1,500</option>
                    <option value="1500-2500">₹1,500 - ₹2,500</option>
                    <option value="2500-4000">₹2,500 - ₹4,000</option>
                    <option value="4000-8000">₹4,000 - ₹8,000</option>
                    <option value="more-than-8000">More than ₹8,000</option>
                  </select>
                )}
                {formData.category === 'commercial' && (
                  <>
                    <input
                      type="text"
                      name="companyName"
                      placeholder="Company Name"
                      value={formData.companyName}
                      onChange={handleInputChange}
                      style={{
                        padding: '0.75rem',
                        border: '1px solid #ddd',
                        borderRadius: '5px',
                        fontSize: '1rem'
                      }}
                    />
                    <select
                      name="monthlyBill"
                      value={formData.monthlyBill}
                      onChange={handleInputChange}
                      required
                      style={{
                        padding: '0.75rem',
                        border: '1px solid #ddd',
                        borderRadius: '5px',
                        fontSize: '1rem'
                      }}
                    >
                      <option value="">Monthly Bill Range *</option>
                      <option value="0-50000">₹0 - ₹50,000</option>
                      <option value="50000-2lacs">₹50,000 - ₹2,00,000</option>
                      <option value="more-than-2lacs">More than ₹2,00,000</option>
                    </select>
                  </>
                )}
                <input
                  type="email"
                  name="email"
                  placeholder="Email (Optional)"
                  value={formData.email}
                  onChange={handleInputChange}
                  style={{
                    padding: '0.75rem',
                    border: '1px solid #ddd',
                    borderRadius: '5px',
                    fontSize: '1rem'
                  }}
                />
                <button 
                  type="submit" 
                  style={{
                    padding: '1rem 2rem',
                    backgroundColor: '#1F3A93',
                    color: 'white',
                    border: 'none',
                    borderRadius: '5px',
                    fontSize: '1.1rem',
                    fontWeight: '600',
                    cursor: 'pointer',
                    transition: 'background-color 0.2s'
                  }}
                  onMouseEnter={(e) => e.target.style.backgroundColor = '#173080'}
                  onMouseLeave={(e) => e.target.style.backgroundColor = '#1F3A93'}
                >
                  Get Free Quote
                </button>
              </form>
            </div>
          </section>

          {/* Offer Structure */}
          <section style={{ marginBottom: '4rem' }}>
            <h2 style={{ 
              textAlign: 'center', 
              fontSize: '2rem', 
              color: '#1F3A93',
              marginBottom: '0.5rem'
            }}>
              {t.offerTitle}
            </h2>
            <p style={{ 
              textAlign: 'center', 
              color: '#666', 
              marginBottom: '2rem',
              fontSize: '1.1rem'
            }}>
              {t.offerSubtitle}
            </p>
            
            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
              gap: '1.5rem',
              marginTop: '2rem'
            }}>
              <div style={{
                backgroundColor: 'white',
                padding: '2rem',
                borderRadius: '10px',
                boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
                textAlign: 'center',
                border: '2px solid #1F3A93'
              }}>
                <h3 style={{ color: '#1F3A93', marginBottom: '1rem', fontSize: '1.3rem' }}>
                  {t.offer3_5}
                </h3>
                <div style={{ fontSize: '2rem', fontWeight: 'bold', color: '#28a745', marginBottom: '0.5rem' }}>
                  ₹10,000
                </div>
                <div style={{ color: '#666', fontSize: '0.9rem' }}>{t.cashback}</div>
              </div>

              <div style={{
                backgroundColor: 'white',
                padding: '2rem',
                borderRadius: '10px',
                boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
                textAlign: 'center',
                border: '2px solid #1F3A93'
              }}>
                <h3 style={{ color: '#1F3A93', marginBottom: '1rem', fontSize: '1.3rem' }}>
                  {t.offer5_8}
                </h3>
                <div style={{ fontSize: '2rem', fontWeight: 'bold', color: '#28a745', marginBottom: '0.5rem' }}>
                  ₹20,000
                </div>
                <div style={{ color: '#666', fontSize: '0.9rem' }}>{t.cashback}</div>
              </div>

              <div style={{
                backgroundColor: 'white',
                padding: '2rem',
                borderRadius: '10px',
                boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
                textAlign: 'center',
                border: '2px solid #1F3A93'
              }}>
                <h3 style={{ color: '#1F3A93', marginBottom: '1rem', fontSize: '1.3rem' }}>
                  {t.offer8_10}
                </h3>
                <div style={{ fontSize: '2rem', fontWeight: 'bold', color: '#28a745', marginBottom: '0.5rem' }}>
                  ₹30,000
                </div>
                <div style={{ color: '#666', fontSize: '0.9rem' }}>{t.cashback}</div>
              </div>

              <div style={{
                backgroundColor: 'white',
                padding: '2rem',
                borderRadius: '10px',
                boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
                textAlign: 'center',
                border: '2px solid #1F3A93'
              }}>
                <h3 style={{ color: '#1F3A93', marginBottom: '1rem', fontSize: '1.3rem' }}>
                  {t.offer10Plus}
                </h3>
                <div style={{ fontSize: '2rem', fontWeight: 'bold', color: '#28a745', marginBottom: '0.5rem' }}>
                  ₹40,000
                </div>
                <div style={{ color: '#666', fontSize: '0.9rem' }}>{t.cashback}</div>
              </div>
            </div>
          </section>

          {/* Benefits Section */}
          <section style={{ marginBottom: '4rem' }}>
            <h2 style={{ 
              textAlign: 'center', 
              fontSize: '2rem', 
              color: '#1F3A93',
              marginBottom: '2rem'
            }}>
              {t.benefitsTitle}
            </h2>
            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
              gap: '2rem'
            }}>
              <div style={{
                backgroundColor: 'white',
                padding: '2rem',
                borderRadius: '10px',
                boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
              }}>
                <h3 style={{ color: '#1F3A93', marginBottom: '1rem' }}>{t.benefit1Title}</h3>
                <p style={{ color: '#666', lineHeight: '1.6' }}>{t.benefit1Desc}</p>
              </div>
              <div style={{
                backgroundColor: 'white',
                padding: '2rem',
                borderRadius: '10px',
                boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
              }}>
                <h3 style={{ color: '#1F3A93', marginBottom: '1rem' }}>{t.benefit2Title}</h3>
                <p style={{ color: '#666', lineHeight: '1.6' }}>{t.benefit2Desc}</p>
              </div>
              <div style={{
                backgroundColor: 'white',
                padding: '2rem',
                borderRadius: '10px',
                boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
              }}>
                <h3 style={{ color: '#1F3A93', marginBottom: '1rem' }}>{t.benefit3Title}</h3>
                <p style={{ color: '#666', lineHeight: '1.6' }}>{t.benefit3Desc}</p>
              </div>
            </div>
          </section>

          {/* How It Works */}
          <section style={{ marginBottom: '4rem' }}>
            <h2 style={{ 
              textAlign: 'center', 
              fontSize: '2rem', 
              color: '#1F3A93',
              marginBottom: '2rem'
            }}>
              {t.howItWorks}
            </h2>
            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
              gap: '2rem'
            }}>
              <div style={{
                backgroundColor: '#f8f9fa',
                padding: '2rem',
                borderRadius: '10px',
                borderLeft: '4px solid #1F3A93'
              }}>
                <h3 style={{ color: '#1F3A93', marginBottom: '1rem' }}>{t.step1Title}</h3>
                <p style={{ color: '#666', lineHeight: '1.6' }}>{t.step1Desc}</p>
              </div>
              <div style={{
                backgroundColor: '#f8f9fa',
                padding: '2rem',
                borderRadius: '10px',
                borderLeft: '4px solid #1F3A93'
              }}>
                <h3 style={{ color: '#1F3A93', marginBottom: '1rem' }}>{t.step2Title}</h3>
                <p style={{ color: '#666', lineHeight: '1.6' }}>{t.step2Desc}</p>
              </div>
              <div style={{
                backgroundColor: '#f8f9fa',
                padding: '2rem',
                borderRadius: '10px',
                borderLeft: '4px solid #1F3A93'
              }}>
                <h3 style={{ color: '#1F3A93', marginBottom: '1rem' }}>{t.step3Title}</h3>
                <p style={{ color: '#666', lineHeight: '1.6' }}>{t.step3Desc}</p>
              </div>
            </div>
          </section>

          {/* CTA Section */}
          <section style={{
            backgroundColor: '#1F3A93',
            color: 'white',
            padding: '3rem 2rem',
            borderRadius: '10px',
            textAlign: 'center',
            marginBottom: '4rem'
          }}>
            <h2 style={{ fontSize: '2rem', marginBottom: '1rem' }}>{t.ctaTitle}</h2>
            <p style={{ fontSize: '1.1rem', marginBottom: '2rem', opacity: '0.9' }}>
              {t.ctaDescription}
            </p>
            <div style={{
              display: 'flex',
              gap: '1rem',
              justifyContent: 'center',
              flexWrap: 'wrap'
            }}>
              <a 
                href="tel:+919148857417"
                style={{
                  backgroundColor: 'white',
                  color: '#1F3A93',
                  padding: '1rem 2rem',
                  borderRadius: '5px',
                  textDecoration: 'none',
                  fontWeight: '600',
                  fontSize: '1.1rem',
                  display: 'inline-block',
                  transition: 'transform 0.2s'
                }}
                onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
                onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
              >
                {t.callNow}
              </a>
            </div>
          </section>

          {/* Navigation to Main Site */}
          <section style={{
            textAlign: 'center',
            padding: '2rem',
            backgroundColor: 'white',
            borderRadius: '10px',
            marginBottom: '2rem'
          }}>
            <Link 
              to="/" 
              style={{
                color: '#1F3A93',
                textDecoration: 'none',
                fontSize: '1.1rem',
                fontWeight: '600'
              }}
            >
              ← {t.navigateToMain}
            </Link>
          </section>

          {/* Disclaimer and Legal Note */}
          <section style={{
            backgroundColor: '#fff3cd',
            padding: '1.5rem',
            borderRadius: '5px',
            border: '1px solid #ffc107',
            marginBottom: '2rem'
          }}>
            <p style={{ 
              color: '#856404', 
              marginBottom: '1rem',
              fontSize: '0.9rem',
              lineHeight: '1.6'
            }}>
              <strong>Disclaimer:</strong> {t.disclaimer}
            </p>
            <p style={{ 
              color: '#856404', 
              fontSize: '0.9rem',
              lineHeight: '1.6'
            }}>
              {t.legalNote}
            </p>
          </section>

          {/* Terms Link */}
          <section style={{ textAlign: 'center', marginBottom: '2rem' }}>
            <Link 
              to={`/referral/terms${window.location.search}`}
              style={{
                color: '#1F3A93',
                textDecoration: 'underline',
                fontSize: '1rem'
              }}
            >
              {t.termsLink}
            </Link>
          </section>
        </main>
        
        {/* Footer */}
        <Footer />
      </div>
    </>
  );
}

export default ReferralLandingPage;

